import { CardStack } from '../card-stack';
import { PaperSize } from '../../../../shared/paper-size';
import { Orientation } from '../../../../enum/dto/orientation.enum';

export abstract class IndexCardStack extends CardStack {
  getCardHeightInInches(): number {
    return 3;
  }

  getCardWidthInInches(): number {
    return 5;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    if (paperSize?.isPerforatedAvery()) {
      return 3;
    }
    return 4;
  }

  nColumns(): number {
    if (this.isOnPerforatedAveryPaper()) {
      return 1;
    }
    return 2;
  }

  nRows(): number {
    if (this.isOnPerforatedAveryPaper()) {
      return 3;
    }
    return 2;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Portrait;
  }
}
